import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@/components/common/Button/Button';
import PremiumButton from '../common/PremiumButton';

/**
 * Register Button Component
 * Navigates to login route with signup modal query param
 * Uses Button component with primary gradient style
 */
const RegisterButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate('/login?modalType=auth-signup');
  };

  return (
    // <Button
    //   variant="explorePremium"
    //   onClick={handleClick}
    // >
    //   Sign up
    // </Button>

    <PremiumButton onClick={handleClick}>{t('auth.signUp')}</PremiumButton>
  );
};

export default RegisterButton;
